<template>
  <v-content style="background-color: #f9f9f9;">
    <div class="point text-center">
      <div style="height: 12px" ></div>
      <span class="headder">こちらの画面をスタッフに提示して下さい</span>
      <div style="height: 15px"></div>
      <span class =""> 会員ID</span>
      <barcode v-model="point.member_id" :options="{ format: this.barcode_format,displayValue: true,width:1}"></barcode>
      <div style="height: 35px"></div>
      <span class="headder " style="line-height:30px;height:30px;width:100%;background-color: #DEDEDF">保有ポイント</span>
      <div style="height: 25px"></div>
      <img @click.stop="getPoint()" src="@/assets/reboot.svg">
      <div style="height: 12px"></div>
      <span class="bigpoint3 ">{{point.point}}</span>
      <div style="height: 10px"></div>
      <span class="smallpoint ">point</span>
      <div style="display:inline-block; ">
        <div style="font-weight: bold;">
          ポイント有効期限： <span style="display: inline-block; width: 140px;">{{ this.point.expiration_date != '' ? getDateFormat(this.point.expiration_date) : null}}</span>
        </div>
      </div>
    </div>
    
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import moment from "moment"
export default {
  data: () => ({
    init: [],
    point:  {point: '', member_id : "", expiration_date: ''},
    barcode_type: null,
    loading: false,
  }),
  created () {
    this.init = this.storageGet("*")
  },
  async mounted() {
    this.loading = true
    try {
      await this.getPoint()
      this.loading = false
    }catch (e) {
      this.loading = false
    }
  },
  computed: {
    barcode_format(){
      let barcodeType = "";
      switch (this.init.external_point_barcode_type){
        case 1:
          barcodeType = 'EAN13'
          break;
        case 2:
          barcodeType = 'CODE128'
          break;
        case 3:
          barcodeType = 'CODE39'
          break;
      }
      return barcodeType
      // CODE128 :CODE128
      // EAN / UPC :EAN13 UPC EAN8 EAN5 EAN2
      // CODE39 :CODE39
      // ITF-14 :ITF14
      // MSI :MSI MSI10 MSI11 MSI1010 MSI1110
      // Pharmacode :pharmacode
      // Codabar :codabar
    },
  },
  methods: {
    getDateFormat(date) {
      var d = moment(date);
      if(d.isValid()) {
        return d.format('YYYY年MM月DD日');
      }
      return date;
    },
    
    async getPoint() {
      this.loading = true
      // 画面再描画時用にsetTimeoutしてthis.loading等の描画に余裕を持たせる。
      await setTimeout( async () => {
        this.loading = true
        try {
          // ポイント情報取得API
          let req = {params: {
              'shop_id': this.init.sid,
              'user_id': this.init.user_id,
            }}

          let res = await this.apiCall('/point-external/ldx-show', req);
          if (!res){
            this.loading = false
            return false;
          }
          this.$set(this, 'point', res);
        } catch(e) {
          this.loading = false
          this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
        }
        this.loading = false
      },100)
    },
  },
};
</script>

<style scoped>
.headder{
  font-weight: bold;
}
img{
  padding-left: 250px;
}
.bigpoint3 {
  font-size: 60px;
  font-weight: bold;
  font-family: "Oswald", sans-serif !important;
  line-height: 1;
}
.spanmessage {
  font-size: 12px;
}
.smallpoint {
  font-size: 24px;
  font-weight: bold;
  font-family: "Oswald", sans-serif !important;
  color: #333333;
}
.point{
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
<style>
.v-application--wrap {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
</style>
